import "./reviews.css"
import manaliImg from "../image/manali.jpg";
import sharanImg from "../image/sharan.jpg";
import riteshImg from "../image/riteshImg.jpg";
import pratikImg from "../image/pratik.jpg";
import sreeragImg from "../image/sreerag.jpg";


import { useState } from "react";


export const Review = () => {

    const [review_obj, setReview_obj] = useState([
        {
            Rimg: sreeragImg,
            Rname: "Sreerag Rajan",
            Rpost: "Jr. Software Engineer",
            Rcompany: "CloudBloom",
            Rmessage: "The project we worked on was very early in our course. So I cannot say much about the skill, because now we have come so much further than then. But what I really appreciate even today was your tenacity and your curiosity. Almost everything was new to us. The navbar that you were working on was something that we had never really built before. Even then, the fact that it was new, did not deter you from trying it. You put in your effort, and dedication to research it, and built an exemplary navbar. That tenacity and drive to excel was the most fantastic thing I had seen. You did not stop just because something was difficult or because something was new. You did not build something shoddy and say 'That is enough. I can't do more'. I could see you giving your best. I feel that is a golden quality to have.",
            Rattachment: "Teammate in SportsJam.in Clone"
        },
        {
            Rimg: pratikImg,
            Rname: "Pratik Singh",
            Rpost: "Learning MERN Stack",
            Rcompany: "Masai School",
            Rmessage: "You have gained great knowledge by exploring and working on different projects. You were always there to help the teammates that shows your quality of a good team player.",
            Rattachment: "Teammate in Freshmenu.com Clone"
        },
        {
            Rimg: manaliImg,
            Rname: "Manali Mohod",
            Rpost: "Learning MERN Stack",
            Rcompany: "Masai School",
            Rmessage: "She has excellent leadership qualities .can solve any problem quickly",
            Rattachment: "Teammate in Freshmenu.com Clone"
        },
        {
            Rimg: sharanImg,
            Rname: "Sharan Dooganavar",
            Rpost: "Learning MERN Stack",
            Rcompany: "Masai School",
            Rmessage: "Its very overwhelming working with you, with higher responsibility and throwing away a good managerial skills within us. You are very committed towards work done. Hope you are capable of handling bigot tasks smoothly, thus creating a steady and progressive environment around you.",
            Rattachment: "Teammate in Netmeds.com Clone, Nordstorm.com Clone"
        },
        {
            Rimg: riteshImg,
            Rname: "Ritesh Kamthe",
            Rpost: "Instructional Associate",
            Rcompany: "Masai School",
            Rmessage: "You are a team player. You do your work with your full potential and try to give your best all the time. You are very cooperative and help others also if they are facing any problems it's a best quality that you have.",
            Rattachment: "Teammate in SportsJam.in Clone"
        }
    ])


    // setTimeout(()=> {
    //     if(current === 2){
    //         setCurrent(0)
    //     } else {
    //         setCurrent(prev => prev + 1)
    //     }
       
    // }, 5000);

    return (
        <div className="aboutContainer">
           
           <div className="headingBtn">
                <p className="heading">Review</p>
                <div></div>

            </div>


            <div className="reviewMainDiv">

                {
                    review_obj.map((el, id) => {
                        
                        return (
                        <div className="reviewDiv" key={id}>

                                <div className="upperReDiv">
                                    <div className="container_upperDiv">
                                        <img src={el.Rimg} alt="img" className="upperImg" />
                                        <div className="upperPDiv">
                                            <p>{ el.Rname }</p>
                                            <p>{el.Rpost}</p>
                                            <p>{el.Rcompany}</p>
                                        </div>
                                    </div>


                                </div>
                                <div className="lowerReDiv">
                                    <p>
                                        "{el.Rmessage}"
                                    </p>

                                    <p>{el.Rattachment}</p>
                                </div>
                            </div>
                        )
                    })
                }



            </div>

        </div>
    )
}